module.exports = __webpack_public_path__ + "static/media/15B.bfbd543a.png";